module.exports = __webpack_public_path__ + "img/ios-document.a692c491.svg";